import { AgGridReactProps } from '@ag-grid-community/react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AgGridColumnDef } from '@tassat/common-definitions';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getUserAccountByPledgeParticipantAccount } from 'Selectors/userAccounts';
import PledgeActionsDropdownMenu, { PledgeAction } from 'SharedComponents/actionsDropdownMenu/pledgeActionsDropdownMenu';
import { PledgeTransactionRow } from 'SharedComponents/modals/pledgeDetailsModal/pledgeContextWorkflow/pledgeContextWorkflowContext';

interface IPledgeActionButtonCellRendererProps extends AgGridReactProps {
    data: PledgeTransactionRow;
    colDef: AgGridColumnDef;
    cellRendererParams?: {
        getActions: (
            data: PledgeTransactionRow,
            userInitiatingAccount: ReturnType<typeof getUserAccountByPledgeParticipantAccount>
        ) => PledgeAction[];
    };
}

const muiStyles = makeStyles({
    root: { height: '100%' },
    showActionsButton: { marginLeft: 'auto' as const }
});

export function PledgeActionButtonCellRenderer(props: IPledgeActionButtonCellRendererProps) {
    const { colDef } = props;

    const classes = muiStyles(props);

    const userInitiatingAccount = useAppSelector(
        (state) => getUserAccountByPledgeParticipantAccount(state, props.data?.PledgeTransactionRequesterAccount)
    );

    const actions: PledgeAction[] = colDef?.cellRendererParams?.getActions?.(props.data, userInitiatingAccount) ?? [];

    if (!actions.length) return <div />;

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='row'
            justifyContent='space-between'
            spacing={0}
            wrap='nowrap'
        >
            <Grid
                className={classes.showActionsButton}
                item
            >
                <PledgeActionsDropdownMenu
                    actions={actions}
                    data={props.data}
                />
            </Grid>
        </Grid>
    );
}

export default PledgeActionButtonCellRenderer;